module.exports = __webpack_public_path__ + "files/2a0b27259f1867317861338ee4d84141.png";